import React from 'react';
import {useTranslation} from 'react-i18next';
import {OFFER_CONFIRMATION_TYPES} from '../../../../utils/upselling';
import {ButtonStyled, Wrapper} from './styled';

export type CaseHeaderProps = {
  confirmationType: OFFER_CONFIRMATION_TYPES;
  formName: string;
  handleBookAndKeepExploring: () => void;
  disabled?: boolean;
  className?: string;
};

function ButtonsBlock({
  disabled,
  formName,
  confirmationType,
  className,
  handleBookAndKeepExploring,
}: CaseHeaderProps) {
  const {t} = useTranslation();

  if (confirmationType === OFFER_CONFIRMATION_TYPES.manual) {
    return (
      <Wrapper className={className}>
        <ButtonStyled
          form={formName}
          label={t('request_experience')}
          iconRight="shoppingBagIcon"
          short
          disabled={disabled}
          type="submit"
        />
      </Wrapper>
    );
  }

  return (
    <Wrapper className={className}>
      <ButtonStyled
        form={formName}
        label={t('pay_now')}
        iconRight="shoppingBagIcon"
        short
        disabled={disabled}
        type="submit"
      />
      <ButtonStyled
        form={formName}
        secondary
        label={t('book_and_keep_exploring')}
        disabled={disabled}
        onClick={handleBookAndKeepExploring}
      />
    </Wrapper>
  );
}

export default ButtonsBlock;
